// extracted by mini-css-extract-plugin
export default {"container":"_21TZC","link":"_1lVoX","term":"_3h1t9"};